import styled from "styled-components";

import Panel from "../Panel";
import Skeleton from "../Skeleton";
import { EARNINGS_NOTE } from "../InfoTip";
import { Member, Product, monthEarnings, formatCurrency } from "../../../utils/partnerMetrics";

const Rows = styled.div`
  display: flex;
  flex-direction: column;
`;

const LineRow = styled.div<{ $total?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px solid #f1ebe3;

  &:first-child {
    border-top: none;
  }

  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: ${({ $total }) => ($total ? "15px" : "14px")};
  font-weight: ${({ $total }) => ($total ? 800 : 500)};
  color: ${({ $total }) => ($total ? "#111111" : "#4a423b")};
`;

const Amount = styled.span<{ $total?: boolean }>`
  font-weight: ${({ $total }) => ($total ? 800 : 700)};
  color: ${({ $total }) => ($total ? "#111111" : "#2a241f")};
`;

interface RevenueOverviewProps {
  members: Member[];
  products: Product[];
  loading?: boolean;
}

const RevenueOverview = ({ members, products, loading }: RevenueOverviewProps) => {
  if (loading) {
    return (
      <Panel title="Earnings This Month">
        {Array.from({ length: 3 }).map((_, i) => (
          <LineRow key={i}>
            <Skeleton $w="40%" $h="14px" />
            <Skeleton $w="60px" $h="14px" />
          </LineRow>
        ))}
      </Panel>
    );
  }

  const earnings = monthEarnings(members, products);

  return (
    <Panel title="Earnings This Month" info={EARNINGS_NOTE}>
      <Rows>
        <LineRow>
          From trials
          <Amount>{formatCurrency(earnings.trialEarnings)}</Amount>
        </LineRow>
        <LineRow>
          From upgrades
          <Amount>{formatCurrency(earnings.upgradeEarnings)}</Amount>
        </LineRow>
        <LineRow $total>
          Total
          <Amount $total>{formatCurrency(earnings.totalEarnings)}</Amount>
        </LineRow>
        {earnings.awaitingCheckIn.count > 0 && (
          <LineRow>
            Awaiting check-in ({earnings.awaitingCheckIn.count})
            <Amount>+{formatCurrency(earnings.awaitingCheckIn.earnings)}</Amount>
          </LineRow>
        )}
      </Rows>
    </Panel>
  );
};

export default RevenueOverview;
